export const USER_ACTIONS = {
	LOG_IN: 'LOG_IN',
	LOG_OUT: 'LOG_OUT',
	RESET_UNREAD_MESSAGES: 'RESET_UNREAD_MESSAGES',
	UPDATE_USER_DETAILS: 'UPDATE_USER_DETAILS',
	UPDATE_PREFERRED_LANGUAGE_ID: 'UPDATE_PREFERRED_LANGUAGE_ID',
};

export const LANGAUGE_ACTIONS = { CHANGE_LANG: 'CHANGE_LANG' };

export const COURSES_ACTIONS = { SET_COURSES: 'SET_COURSES', SET_CURRENT_COURSE: 'SET_CURRENT_COURSE', SET_COURSE_TEST: 'SET_COURSE_TEST' };
